import React, { CSSProperties } from "react";

interface NavCTAExportProps {
  text?: string;
  href?: string;
  backgroundColor?: string;
  textColor?: string;
  borderRadius?: number;
  paddingX?: number;
  paddingY?: number;
  fontSize?: number;
  fontWeight?: number;
}

export const NavCTAExport: React.FC<NavCTAExportProps> = ({
  text = "Book Now",
  href = "/contact",
  backgroundColor = "var(--color-primary, #3b82f6)",
  textColor = "#ffffff",
  borderRadius = 8,
  paddingX = 20,
  paddingY = 8,
  fontSize = 14,
  fontWeight = 500,
}) => {
  const buttonStyle: CSSProperties = {
    display: "inline-block",
    color: textColor,
    backgroundColor: backgroundColor,
    paddingTop: `${paddingY}px`,
    paddingBottom: `${paddingY}px`,
    paddingLeft: `${paddingX}px`,
    paddingRight: `${paddingX}px`,
    borderRadius: `${borderRadius}px`,
    fontWeight: fontWeight,
    fontSize: `${fontSize}px`,
    textDecoration: "none",
    whiteSpace: "nowrap",
    flexShrink: 0,
  };

  return (
    <a href={href} className="nav-cta" style={buttonStyle}>
      {text}
    </a>
  );
};
